import { EMPTY, Observable, of, switchMap } from 'rxjs';
import { AjaxConfig, AjaxResponse } from 'rxjs/ajax';

import { AppStore } from 'app/store';
import { LocalDownloader } from 'app/utils/local-downloader';

import { HttpHandler } from '../http-handler';
import { Interceptor } from '../interceptor';

export class DownloadInterceptor implements Interceptor {
    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        return next.handle(req).pipe(
            switchMap((response) => {
                const disposition = response.responseHeaders['content-disposition'];

                if (!disposition || -1 === disposition.indexOf('attachment')) {
                    return of(response);
                }

                let filename = '';
                const blob = response.response;

                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition) || [];
                if (matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }

                LocalDownloader.downloadBlob(blob, filename);

                return EMPTY;
            }),
        );
    }
}
